<fgb-page-header [backButtonLink]="'/games'" [pageTitle]="'games.page.predictor'" [showFooter]="false" [showBanner]="false"/>

<!--Banner-->
<fgb-portal-games-banner [isPredictorPage]="true"></fgb-portal-games-banner>

<div class="container ">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
